<micro-lookup domain="sql" obj="sqls" url="/sqls" [key]="sqlId"></micro-lookup>
